import { Compass } from 'lucide-react';
import { ButtonLink, EmptyState } from '@/components/ui';

export function NotFound() {
  return (
    <div className="py-10">
      <EmptyState
        icon={<Compass className="size-5" aria-hidden />}
        title="Page not found"
        actions={
          <ButtonLink to="/" variant="primary">
            Go to the dashboard
          </ButtonLink>
        }
      >
        <h1 className="sr-only">Page not found</h1>
        That page doesn’t exist, or it was moved.
      </EmptyState>
    </div>
  );
}
